
import { computed, defineComponent } from 'vue';
import { useRoute } from 'vue-router';

    function bespokeComposition () {
		/**
		 * Endpoint
		 */
		const route = useRoute();
		const endpointId = computed((): string => {
			return route.params.endpointId as string;
		});

		return { endpointId }
	}

    export default defineComponent({
        setup() {
            return { ...bespokeComposition() }
        },
    })
